
import React from 'react';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";
import { Trophy } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { Challenge } from '../../../types/game';

interface AchievementsTabProps {
  achievements: string[];
}

const AchievementsTab: React.FC<AchievementsTabProps> = ({ achievements }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 flex items-center text-web3-green">
        <Trophy className="mr-2 h-5 w-5" />
        Career Achievements
      </h3>
      
      {achievements.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          <p>No achievements yet</p>
          <p className="text-sm">Complete challenges to earn achievements</p>
        </div>
      ) : (
        <ScrollArea className="h-[240px]">
          <div className="space-y-2">
            {achievements.map((achievement, index) => (
              <div 
                key={index} 
                className="border border-web3-green/20 bg-web3-green/5 p-3 rounded-md flex items-start justify-between"
              >
                <div>
                  <div className="font-medium">{achievement}</div>
                  <div className="text-xs text-muted-foreground">
                    {formatDistanceToNow(new Date(Date.now() - (index * 1000 * 60 * 60 * 24 * 30)))} ago
                  </div>
                </div>
                <Badge variant="secondary" className="ml-2 bg-web3-green/20">
                  +{Math.floor(Math.random() * 30 + 10)} XP
                </Badge>
              </div>
            ))}
          </div>
        </ScrollArea>
      )}
    </div>
  );
};

export default AchievementsTab;
